export default {
  CONTRACTS__UPDATE_LOADING(state, value) {
    state.loading = value;
  },
  CONTRACTS__UPDATE_LIST_LOADING(state, value) {
    state.listLoading = value;
  },
  CONTRACTS__UPDATE_LIST(state, value) {
    state.items = value;
  },
  CONTRACTS__UPDATE_TOTAL(state, value) {
    state.total = value;
  },
  CONTRACTS__UPDATE_PAGE_NO(state, value) {
    state.pageNo = value;
  },
  CONTRACTS__UPDATE_PAGE_SIZE(state, value) {
    state.pageSize = value;
  },
  CONTRACTS__UPDATE_ITEM(state, value) {
    state.item = value;
  },
  CONTRACTS__REFRESH_LIST(state) {
    state.refreshList = !state.refreshList;
  },
  CONTRACTS__REFRESH_GROUPS_LIST(state) {
    state.groups.refreshList = !state.groups.refreshList;
  },
  CONTRACTS__UPDATE_GROUPS_LOADING(state, value) {
    state.groups.loading = value;
  },
  CONTRACTS__UPDATE_GROUPS_LIST_LOADING(state, value) {
    state.groups.listLoading = value;
  },
  CONTRACTS__UPDATE_GROUPS_LIST(state, value) {
    state.groups.items = value;
  },
  CONTRACTS__UPDATE_GROUPS_TOTAL(state, value) {
    state.groups.total = value;
  },
  CONTRACTS__UPDATE_GROUPS_PAGE_NO(state, value) {
    state.groups.pageNo = value;
  },
  CONTRACTS__UPDATE_GROUPS_PAGE_SIZE(state, value) {
    state.groups.pageSize = value;
  },
};
